import PropTypes from "prop-types";
import {
  ApplicationsRow,
  ClientRow,
  DashboardRow,
  IllustrationRow,
  RollupRow,
  InterestServicingRollupRow,
  FurtherAdvanceRow,
} from "./rows";
import { CONFIGURATIONS } from "./configurations";
import classNames from "classnames/bind";
import styles from "./ZebraTable.module.scss";

const cx = classNames.bind(styles);

const ZebraTable = ({ configuration, tableData, options }) => {
  const tableHeadings = CONFIGURATIONS[configuration];

  const tableHeadingItem = (item, index) => {
    const { label, width, nowrap } = item;

    return (
      <th
        key={index}
        className={cx("headingCell", { ["u-nowrap"]: nowrap })}
        style={width && { width: `${width}%` }}
      >
        {headingLabel(configuration, label)}
      </th>
    );
  };

  const headingLabel = (configuration, label) => {
    switch (configuration) {
      case "interestServiceRollup":
        return replaceVariables(label, {
          rate_monthly: options?.rate_monthly,
          rate_monthly_without_discount: options?.rate_monthly_without_discount,
        });
      default:
        return label;
    }
  };

  const replaceVariables = (text, variables) => {
    return text.replace(/#(\w+)#/g, (_, key) => variables[key] || "");
  };

  return (
    <table className={cx("table")}>
      <thead className={cx("tableHeader")}>
        <tr>{tableHeadings.map(tableHeadingItem)}</tr>
      </thead>
      <tbody>
        {tableData.map((item, index) => {
          switch (configuration) {
            case "dashboard": {
              return <DashboardRow key={index} {...item} />;
            }

            case "illustration": {
              return <IllustrationRow key={index} {...item} />;
            }

            case "client": {
              return <ClientRow key={index} {...item} />;
            }

            case "applications":
            case "applicationsForAdmin": {
              return <ApplicationsRow key={index} {...item} />;
            }

            case "rollup": {
              return <RollupRow key={index} {...item} />;
            }

            case "interestServiceRollup": {
              return <InterestServicingRollupRow key={index} {...item} />;
            }

            case "furtherAdvance": {
              return <FurtherAdvanceRow key={index} {...item} />;
            }

            default:
              return null;
          }
        })}
      </tbody>
    </table>
  );
};

ZebraTable.propTypes = {
  configuration: PropTypes.oneOf(Object.keys(CONFIGURATIONS)).isRequired,
  tableData: PropTypes.array.isRequired,
  options: PropTypes.object,
};

export default ZebraTable;
